// extracted by mini-css-extract-plugin
export default {"productGrid":"k1-z","centerLink":"l1-z","productSection":"m1-z","item":"n1-z","ctaButton":"o1-z"};